<template>
  <article class="product-preview">
    <a class="product-preview__content" :href="href">
      <div class="product-preview__image">
        <picture>
          <img :src="imageSrc" :alt="'Изображение ' + title" loading="lazy">
        </picture>
      </div>
      <ul class="product-preview__tags" v-if="tags.length">

        <li class="product-preview__tag" :class="getTagClass(tag.color)" v-for="(tag, index) in tags" :key="index">
          <svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" viewBox="0 0 69 28" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.74071 0C16.35 0 27.959 0.893771 39.5683 0.893771C47.7989 0.893771 56.0297 0 64.2603 0C66.8676 0 69.0005 2.53476 69.0005 5.63334C69.0005 8.41556 68.6396 11.1621 68.6396 13.9443C68.6396 16.7398 69.0005 19.5711 69.0005 22.3667C69.0005 25.4652 66.8676 28 64.2603 28C50.6827 28 37.1051 27.0677 23.5275 27.0677C17.2652 27.0677 11.003 28 4.74071 28C2.13338 28 0.000488281 25.4652 0.000488281 22.3667C0.000488281 19.4314 0.364478 16.5253 0.364478 13.59C0.364478 10.9475 0.000488281 8.27581 0.000488281 5.63334C0.000488281 2.53476 2.13338 0 4.74071 0Z" fill="currentColor"></path></svg>
          {{ tag.title }}
        </li>
      </ul>
      <div class="product-preview__description">
        <h3 class="product-preview__title">{{ title }}</h3>
      </div>
    </a>
    <product-icons class="product-icons--mod_product-preview" v-if="icons.length" :data="icons"></product-icons>

  </article>
</template>

<script>
export default {
  name: "ProductPreview",
  props: {
    title: { type: String, required: true, },
    imageSrc: { type: String, required: true, },
    href: { type: String, required: true, },
    icons: { type: Array, required: true, },
    tags: { type: Array, required: true, },
  },
  methods: {
    getTagClass(color) {
      const classMap = {
        green: "product-preview__tag--green",
        orange: "product-preview__tag--orange",
      };
      return classMap[color] || "";
    },
  },
};
</script>

<style lang="scss">
@use '/frontend/scss/base/media.scss' as media;
@use '/frontend/scss/base/variables.scss' as var;

.product-preview {
  height: 100%;

  &__content {
    height: 100%;
    position: relative;
    color: var.$text-brand;
    background-color: var.$colorAliceBlue;
    text-align: center;
    mask-image: url("/frontend/assets/img/product/product-preview-mask.svg");
    mask-size: 100% 100%;
    mask-repeat: no-repeat;
    mask-position: center center;

    display: flex;
    flex-direction: column;
    @include media.fluid('gap', 10px);
    @include media.fluid('padding', 40px, 40px 20px);
  }

  &__image {
    @include media.fluid('height', 200px, 190px, 240px);
  }

  & .product-preview__image img {
    height: 100%;
    width: auto;
    object-fit: contain;
  }

  &__tags {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    @include media.fluid('gap', 4px);
    margin: 0;
  }

  &__tag {
    z-index: 1;
    position: relative;
    font-family: CeraRoundPro, Helvetica, Arial, sans-serif;
    font-weight: 500;
    display: inline-flex;
    @include media.fluid('font-size', 10px, 12px);
    @include media.fluid('line-height', 14px, 16px);
    @include media.fluid('padding', 4px 6px);
    color: #00B5ED;
    margin: 0;

    & > svg {
      color: #CAEDFF;
    }

    &--green {
      color: #fff;
      & > svg {
        color: #579c0e;
      }
    }

    &--orange {
      color: #fff;
      & > svg {
        color: #F9A624;
      }
    }

    & > svg {
      position: absolute;
      z-index: -1;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
    }
  }

  &__title {
    @include media.fluid('font-size', 18px, 18px);
    @include media.fluid('line-height', 24px, 24px);
    font-weight: 700;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  & .product-icons--mod_product-preview {
    position: absolute;
    @include media.fluid('top', 26px);
    @include media.fluid('right', 26px);

    & > .product-icons__item span {
      @include media.fluid('width', 32px);
      @include media.fluid('height', 32px);
    }
  }
}

</style>
